import { CHANGE_INSTITUTION } from "./institutionTypes"

export const changeInstitution = (institutionID) => {
    return {
        type: CHANGE_INSTITUTION,
        id: institutionID
    }
}